import { Component, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';

@Component({
  selector: 'app-paymentprocess',
  templateUrl: './paymentprocess.component.html',
  styleUrls: ['./paymentprocess.component.css']
})
@TraceClassDecorator()
export class PaymentprocessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
